import React from "react";
import MainRouter from "./Components/MainRouter";


const App = () => {
  return (
  <MainRouter />
  );
}


export default App;
